// extracted by mini-css-extract-plugin
export default {"container":"assessment_container__GqgdM","Link":"assessment_Link__g3i84"};